import { useEffect, useState } from "react";
import {
  Avatar,
  Container,
  IconButton,
  InputLabel,
  MenuItem,
  Rating,
  Select,
} from "@mui/material";
import { useIsMounted } from "hooks";
import Lottie from "react-lottie";
import { notFound } from "asset/animations";
import moment from "moment";
import useDataFetch, { useProducts } from "hooks/useDataFetch";
import { getArrFromNestedSnap } from "@ashirbad/js-core";
import { onValue, ref } from "firebase/database";
import { database } from "configs/firebaseConfigs";
import Swal from "sweetalert2";
import { Delete } from "@mui/icons-material";
import { useAppContext } from "contexts";
import { db } from "hooks";

const Reviews = (props) => {
  const [sortBy, setSortBy] = useState("newer");
  const [filteredData, setFilteredData] = useState([]);
  const [allReview, setAllReview] = useState([]);
  const handleSort = (event) => {
    setSortBy(event.target.value);
  };

  const { user } = useAppContext();

  const isMounted = useIsMounted();
  const product = useProducts();

  const allServerReviews = useDataFetch("reviews");

  // console.log(allServerallReview);

  useEffect(() => {
    if (isMounted.current) {
      if (!props?.supplier) return;
      if (!product?.data) return;

      let supplierProduct = product?.data?.filter((item) => {
        return item?.supplierId === props?.id;
      });

      // console.log(supplierProduct);

      onValue(ref(database, "reviews"), (snap) => {
        if (snap.exists()) {
          let allReviews = getArrFromNestedSnap(snap);
          let filteredReviews = allReviews.filter((item) => {
            return supplierProduct?.some((product) => {
              return product?.id === item?._id;
            });
          });
          setAllReview(filteredReviews || []);
        }
      });
    }
  }, [
    isMounted,
    product?.data,
    props?.supplier,
    allServerReviews?.data,
    props?.id,
  ]);

  // console.log(allReview);

  const reviews = useDataFetch(`reviews/${props?.id}`);

  useEffect(() => {
    if (isMounted.current) {
      if (!reviews?.data) return;
      setAllReview(reviews?.data);
    }
  }, [isMounted, reviews?.data]);

  const notFoundLottie = {
    loop: false,
    autoplay: true,
    animationData: notFound,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // console.log(reviews?.data);

  // console.log(props);

  // console.log(allReview);

  useEffect(() => {
    if (isMounted.current) {
      if (allReview && allReview?.length > 0 && sortBy === "newer") {
        let newData = [...allReview]
          ?.sort((a, b) => {
            return new Date(a.createdAt) - new Date(b.createdAt);
          })
          .reverse();

        setFilteredData(newData);
      } else {
        setFilteredData(allReview);
      }
    }
  }, [allReview, isMounted, sortBy]);

  const deleteReview = async (product, user) => {
    try {
      // console.log(product);
      // console.log(user);
      if (!user.role === "super-admin") return;
      await db.delateData(`reviews/${product}/${user}`);
      Swal.fire({
        title: "Deleted!",
        text: "User review has been deleted.",
        icon: "success",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <section className="reviews-section-main">
      <Container>
        <div className="review-section-inner">
          <div className="reviews-section-header">
            <h3 className="review-section-header-title">Reviews</h3>
            {allReview && allReview?.length > 0 && (
              <div className="review-header-content flex-row flex-wrap gap-1 align-items-center justify-content-between w-100">
                <p>
                  {" "}
                  {allReview?.length} Reviews for {props?.title}
                </p>
                <span className="flex-row  align-items-center review-sort-header-section-span">
                  <InputLabel>SORT BY :</InputLabel>
                  <Select
                    value={sortBy}
                    onChange={handleSort}
                    className="review-sort-select"
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="newer">
                      <p>Newest First</p>
                    </MenuItem>
                    <MenuItem value="older">
                      <p>Oldest First</p>
                    </MenuItem>
                  </Select>
                </span>
              </div>
            )}
          </div>
          <div className="reviews-main-review-section flex-column ">
            {allReview && filteredData?.length > 0 ? (
              filteredData?.map((review) => {
                return (
                  <div
                    className="reviews-children flex-row justify-content-between "
                    key={review?.id}
                  >
                    <div className="review-children-left flex-row align-items-center gap-2">
                      <span className="review-children-profile-img">
                        <Avatar
                          src={review?.user?.photoURL}
                          alt={review?.user?.displayName}
                        />
                      </span>
                      <span className="reviews-children-profile-details flex-column gap-1 ">
                        <span className="reviewer-name">
                          <p>{review?.user?.displayName}</p>
                        </span>
                        {/* <span className="reviewer-location">
                          <p>Saudi Arabia</p>
                        </span> */}
                      </span>
                    </div>
                    <div className="review-children-right flex-column gap-2">
                      <div className="reviewer-impression flex-row align-items-center gap-2">
                        <span className="reviewer-rating flex-row align-items-center ">
                          <Rating
                            name="review-rating "
                            value={review?.rating}
                          />
                        </span>

                        <span className="reviewer-date  ">
                          {" "}
                          {moment(review?.createdAt).format("LLL")}{" "}
                        </span>
                      </div>
                      <div className="review-message">{review?.review}</div>
                    </div>
                    {user?.role === "super-admin" && (
                      <span className="delete-review">
                        <IconButton
                          sx={{
                            color: "red",
                            cursor: "pointer",
                            width: "fit-content",
                          }}
                          aria-label="delete"
                          onClick={() => {
                            deleteReview(review?._id, review?.id);
                          }}
                        >
                          <Delete />
                        </IconButton>
                      </span>
                    )}
                  </div>
                );
              })
            ) : (
              <div
                className="flex-row align-items-center justify-content-center "
                style={{ minHeight: "50vh" }}
              >
                <Lottie options={notFoundLottie} height={350} width={350} />
              </div>
            )}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Reviews;
